import { useAppInitTask } from '@if/mui'
import { useGetSystemFlowSwitch } from '@src/api/config-api'
import { SystemFlowContext, type SystemFlowConfig } from '@src/contexts/system-flow-context'
import type { FC, ReactNode } from 'react'

const EMPTY_CONFIG: SystemFlowConfig = {}

interface SystemFlowProviderProps {
  children: ReactNode
}

export const SystemFlowProvider: FC<SystemFlowProviderProps> = ({ children }) => {
  const { data, isPending } = useGetSystemFlowSwitch()

  useAppInitTask(!isPending, 'systemFlowConfig')

  if (isPending) return null

  return (
    <SystemFlowContext.Provider value={data?.systemFlowSwitch.systemFlowConfig ?? EMPTY_CONFIG}>
      {children}
    </SystemFlowContext.Provider>
  )
}
